import { ANALYTICS_CLICK_BELL_SUBSCRIBE } from '../constants/analytics';
import {
  TOGGLE_FILTERS_PANEL,
  TOGGLE_SUBSCRIBE_POPUP,
  SET_IS_HOTEL_ONLY,
} from '../constants/view';

export const toggleFiltersAction = (payload) => ({
  type: TOGGLE_FILTERS_PANEL,
  payload,
});

export const toggleSubscribeAction = () => ({
  type: TOGGLE_SUBSCRIBE_POPUP,
});

export const analyticsClickBellSubscribe = () => ({
  type: ANALYTICS_CLICK_BELL_SUBSCRIBE,
});

export const setIsHotelOnly = (payload: boolean) => ({
  type: SET_IS_HOTEL_ONLY,
  payload,
});
